
import { authConstants } from '../constants/auth';

const hours = 1; // Reset when storage is more than 24hours
const now = new Date().getTime();
const setupTime = localStorage.getItem('setupTime');

if (setupTime == null) {
  localStorage.setItem('setupTime', now);
} else if (now - setupTime > hours * 60 * 60 * 1000) {
  localStorage.clear();
  localStorage.setItem('setupTime', now);
}

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? {
  loggedIn: true,
  user,
} : {};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user,
      };
    case authConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
      };
    case authConstants.LOGIN_FAILURE:
      return {};
    case authConstants.LOGOUT:
      return {};
    default:
      return state;
  }
};

export default auth;
